import { useState, useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const DecodingText = ({ text, className = "", delay = 0 }) => {
  const [displayText, setDisplayText] = useState(text.split('').map(() => '█').join(''));
  const [hasDecoded, setHasDecoded] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*!';

  useEffect(() => {
    if (isInView && !hasDecoded) {
      const timer = setTimeout(() => {
        let iterations = 0;
        const maxIterations = text.length * 3; // More iterations for longer scramble

        const interval = setInterval(() => {
          setDisplayText(
            text
              .split('')
              .map((char, index) => {
                if (char === ' ' || char === '_') return char;
                if (index < iterations / 3) return text[index];
                return characters[Math.floor(Math.random() * characters.length)];
              })
              .join('')
          );

          iterations += 1;

          if (iterations >= maxIterations) {
            clearInterval(interval);
            setDisplayText(text);
            setHasDecoded(true);
          }
        }, 40);

        return () => clearInterval(interval);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [isInView, text, delay, hasDecoded]);

  return (
    <span ref={ref} className={className}>
      {displayText}
    </span>
  );
};

export default DecodingText;
